const AudioContext = window.AudioContext || window['webkitAudioContext']

const context = new AudioContext()
let osc1: OscillatorNode
let osc2: OscillatorNode

export const play = (signal: Signal) => {
  const frequencyPair = dtmfFrequencies[signal]

  playFreq(frequencyPair[0], frequencyPair[1])
}

export const stop = () => {
  try {
    osc1.stop()
    osc2.stop()
  } catch (e) {
    // console.warn()
  }
}

const playFreq = (freq1: number, freq2: number) => {
  if (osc1) {
    stop()
  }

  osc1 = context.createOscillator()
  osc2 = context.createOscillator()

  osc1.frequency.value = freq1
  osc2.frequency.value = freq2

  const gainNode = context.createGain()
  gainNode.gain.value = 0.2

  const filter = context.createBiquadFilter()
  filter.type = 'lowpass'
  filter.frequency.setValueAtTime(8000, context.currentTime)

  osc1.connect(gainNode)
  osc2.connect(gainNode)

  gainNode.connect(filter)
  filter.connect(context.destination)

  osc1.start(0)
  osc2.start(0)
}

var dtmfFrequencies = {
  '1': [697, 1209],
  '2': [697, 1336],
  '3': [697, 1477],
  '4': [770, 1209],
  '5': [770, 1336],
  '6': [770, 1477],
  '7': [852, 1209],
  '8': [852, 1336],
  '9': [852, 1477],
  '*': [941, 1209],
  '0': [941, 1336],
  '#': [941, 1477],
}

export const signalKeys = Object.keys(dtmfFrequencies)

export type Signal =
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '*'
  | '0'
  | '#'
